/*
  Ivy Pillow — doorlopende CSS-animaties (marquee, reviewkolommen,
  hotspot-pulsjes) pauzeren zodra ze buiten beeld zijn. Ze bleven anders de
  hele pagina lang compositie- en tekenwerk doen, wat het scrollen kan laten
  haperen. Puur een prestatiemaatregel: in beeld verandert er niets.
*/
(() => {
  const SELECTORS = [
    '.ivy-marquee',
    '.ivy-reviews__kaarten',
    '.ivy-lookbook__kaart',
    '.ivy-vergelijking__scrollhint',
  ].join(',');

  function init() {
    if (!('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('ivy-anim-uit', !entry.isIntersecting);
        });
      },
      { rootMargin: '200px 0px' }
    );

    document.querySelectorAll(SELECTORS).forEach((el) => io.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
